import { getAtomUsdPrice as getAtomUsdPriceFromSdk } from '@veno-app/sdk';

import { QueryKey } from './queryKey';

interface FetchCurrencyRatesResponse {
  code: number;
  data: { crypto: Record<string, number>; fiat: Record<string, number> };
}

interface VvsFetchResponse {
  data: Record<
    string,
    { price: string; name: string; symbol: string; price_CRO: string }
  >;
}

const FETCH_URI = 'https://price-api.crypto.com/price/v1/currency/all';
const FETCH_URI_VVS = 'https://api.vvs.finance/info/api/tokens';

export const getCroUsdPrice = () => ({
  queryKey: [QueryKey.CRO_PRICE],
  queryFn: async () => {
    const fetchResponse = await fetch(FETCH_URI);
    const response = (await fetchResponse.json()) as FetchCurrencyRatesResponse;

    const croPerUsd = response.data.crypto['CRO'];
    if (croPerUsd) return 1 / croPerUsd;
    throw new Error(
      'Could not fetch CRO asset price from price-api.crypto.com',
    );
  },
});

export const getEthUsdPrice = () => ({
  queryKey: ['eth-price'],
  queryFn: async () => {
    const fetchResponse = await fetch(FETCH_URI);
    const response = (await fetchResponse.json()) as FetchCurrencyRatesResponse;

    const ethPerUsd = response.data.crypto['ETH'];
    if (ethPerUsd) return 1 / ethPerUsd;
    throw new Error(
      'Could not fetch ETH asset price from price-api.crypto.com',
    );
  },
});

export const getAtomUsdPrice = () => ({
  queryKey: [QueryKey.ATOM_PRICE],
  queryFn: getAtomUsdPriceFromSdk,
});

export const getVnoUsdPrice = () => ({
  queryKey: [QueryKey.VNO_PRICE],
  queryFn: async () => {
    const fetchResponse = await fetch(FETCH_URI_VVS);
    const response = (await fetchResponse.json()) as VvsFetchResponse;

    const price = parseFloat(
      response.data['0xdb7d0A1eC37dE1dE924F8e8adac6Ed338D4404E9']?.price,
    );
    if (price) return price;
    throw new Error('Could not fetch VNO asset price from vvs finance api');
  },
});

type FetchTokenPriceResponse = {
  slug: string;
  usd_price: number;
};
export const getWcroUsdPrice = () => ({
  queryKey: [QueryKey.WCRO_PRICE],
  queryFn: async () => {
    const fetchResponse = await fetch(
      'https://price-api.crypto.com/price/v1/token-price/wrapped-cro',
    );
    const response = (await fetchResponse.json()) as FetchTokenPriceResponse;
    if (response.usd_price) return response.usd_price;
    throw new Error(
      'Could not fetch WCRO asset price from price-api.crypto.com',
    );
  },
});
